import './ConfirmationWIFIDialog.scss'
import { Dialog, DialogContent, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
    showPopUp: boolean;
    hidePopUp: () => void;
}

const ConfirmationWIFIDialog = ({showPopUp, hidePopUp}: Props) => {
    const { t } = useTranslation();
    return (
        <Dialog
            className="wifi-dialog"
            disableEscapeKeyDown
            onClose={hidePopUp}
            open={showPopUp}
            maxWidth="lg"
        >
            <DialogContent className="wifi-dialog-content">
                <div className="wifi-dialog-container">
                    <p className="wifi-dialog-title">{t('dialog.wifiConnectInfo.title')}</p>
                    <ol>
                        {t('dialog.wifiConnectInfo.instructions').split('\n').map((instruction, i) => (
                            <li key={i}>{instruction}</li>
                        ))}
                    </ol>
                </div>
                <Button className="wifi-dialog-btn" onClick={hidePopUp}>
                    {t('buttons.close')}
                </Button>
            </DialogContent>
        </Dialog>
    )
}

export default ConfirmationWIFIDialog;

